<template>
	<div id="dicom_menu" class="dropdown dropright dropdown-submenu border-bottom-item">
		<button class="dropdown-item" type="button">
			Dicom View
		</button>
		<div id="dicomSubMenu" class="dropdown-menu secondary-menu">
			<label v-if="!isMobileDevice" class="dropdown-item border-bottom-item dicom-on-item" for="cbAllOrientations"
				@click.prevent.stop="allOnClick">
				<div class="form-check form-check-inline flex-menu-item">
					<span class="form-check-label">All Views</span>
					<!-- <span class="form-check-label">{{ isMobileDevice ? 'Visible' : 'All Views' }} </span> -->
					<div class="flex-separator"></div>
					<input id="cbAllOrientations" class="form-check-input" type="checkbox" v-model="isAllLocal"
						@click.stop="allOnClick">
				</div>
			</label>
			<!-- v-if="!isMobileDevice" -->
			<label class="dropdown-item border-bottom-item dicom-on-item" for="cbAxial"
				@click.prevent.stop="axialOnClick">
				<div class="form-check form-check-inline flex-menu-item">
					<span class="form-check-label">Axial</span>
					<div class="flex-separator"></div>
					<input id="cbAxial" class="form-check-input" type="checkbox" v-model="isAxialLocal"
						@click.stop="axialOnClick">
				</div>
			</label>
			<label class="dropdown-item border-bottom-item dicom-on-item" for="cbSaggital"
				@click.prevent.stop="saggitalOnClick">
				<div class="form-check form-check-inline flex-menu-item">
					<span class="form-check-label">Saggital</span>
					<div class="flex-separator"></div>
					<input id="cbSaggital" class="form-check-input" type="checkbox" v-model="isSaggitalLocal"
						@click.stop="saggitalOnClick">
				</div>
			</label>
			<label class="dropdown-item border-bottom-item dicom-on-item" for="cbCoronal"
				@click.prevent.stop="coronalOnClick">
				<div class="form-check form-check-inline flex-menu-item">
					<span class="form-check-label">Coronal</span>
					<div class="flex-separator"></div>
					<input id="cbCoronal" class="form-check-input" type="checkbox" v-model="isCoronalLocal"
						@click.stop="coronalOnClick">
				</div>
			</label>

			<button class="dropdown-item border-bottom-item" disabled type="button">
				<label class="disabled-label">
					QUALITY
				</label>
			</button>

			<label class="dropdown-item border-bottom-item" for="cbDicomLow" @click.prevent.stop="dicomLowClick">
				<div class="form-check form-check-inline flex-menu-item">
					<span class="form-check-label">Basic</span>
					<div class="flex-separator"></div>
					<input id="cbDicomLow" class="form-check-input dicom-on-item" type="checkbox" v-model="isLowQuality"
						@click.stop="dicomLowClick">
				</div>
			</label>
			<label v-if="dicomMiddleLink" class="dropdown-item border-bottom-item" for="cbDicomMiddle"
				@click.prevent.stop="dicomMiddleClick">
				<div class="form-check form-check-inline flex-menu-item">
					<span class="form-check-label">High</span>
					<div class="flex-separator"></div>
					<input id="cbDicomMiddle" class="form-check-input dicom-on-item" type="checkbox"
						v-model="isMiddleQuality" @click.stop="dicomMiddleClick">
				</div>
			</label>
			<label v-if="dicomHighLink" class="dropdown-item border-bottom-item" for="cbDicomHigh"
				@click.prevent.stop="dicomHighClick">
				<div class="form-check form-check-inline flex-menu-item">
					<span class="form-check-label">Original (Highest)</span>
					<div class="flex-separator"></div>
					<input id="cbDicomHigh" class="form-check-input dicom-on-item" type="checkbox"
						v-model="isHighQuality" @click.stop="dicomHighClick">
				</div>
			</label>

			<button v-if="!isOnlyDicom" class="dropdown-item border-bottom-item dicom-on-item" disabled type="button">
				<label class="disabled-label">
					MODES
				</label>
			</button>

			<label v-if="!isOnlyDicom" class="dropdown-item border-bottom-item dicom-on-item" type="button"
				@click="annotationModeClick(false)">
				Annotation Mode
			</label>

			<label v-if="!isOnlyDicom" class="dropdown-item border-bottom-item dicom-on-item" type="button"
				@click="annotationModeClick(true)">
				Annotation Mode With Bones
			</label>

			<!-- <label v-if="!isOnlyDicom" class="dropdown-item border-bottom-item dicom-on-item" type="button"
				@click="analysisModeClick()">
				3D Analysis
			</label> -->


			<button v-if="!isOnlyDicom" class="dropdown-item border-bottom-item dicom-on-item" disabled type="button">
				<label class="disabled-label">
					REPORTS
				</label>
			</button>

			<label v-if="!isOnlyDicom" class="dropdown-item border-bottom-item dicom-on-item" type="button"
				@click="crossSectionReportClick">
				Cross Section Report
			</label>
		</div>
	</div>
	<!-- <li class="nav-item dropdown active">
				<a class="nav-link" 
				tabindex="0" v-on:click="hideSecondaryMenu()"
				data-toggle="dropdown" 
				data-submenu 
				aria-expanded="false">Dicom</a>

				<div class="dropdown-menu dropdown-menu-right" >
					<div class="dropdown dropright dropdown-submenu border-bottom-item">
						<button class="dropdown-item implant-disabled" type="button">
							Load
						</button>
						<div class="dropdown-menu secondary-menu">
							<button class="dropdown-item border-bottom-item" type="button">
								Lossless
							</button>
							<button class="dropdown-item border-bottom-item" type="button">
								Compressed
							</button>
						</div>
					</div>
				</div>
			</li> -->
</template>

<script>
import { mutationTypes } from '@/store/modules/dicom';
import {
	DicomInitialized, updateDicomZipUrl, updateAppLayout, hideAllDicomPanels,
	changeAppTool
} from "../DicomManager.js";
import {
	generateCrossSectionReport
} from "../reports/DicomReports.js";

import { enterAnalysisMode } from "../analysis/AnalysisManager.js";

export default {
	name: "DicomMenu",
	props: [
		"isMobileDevice",
		"dicomLowLink",
		"dicomMiddleLink",
		"dicomHighLink",
		"isOnlyDicom"
	],
	data() {
		return {
			isLoaded: false,
			isFirstLoad: true,
		};
	},
	computed: {
		isAllLocal: {
			get: function () {
				return this.$store.state.dicom.isAxial
					&& this.$store.state.dicom.isSaggital
					&& this.$store.state.dicom.isCoronal;
			},
			set: function (value) {
				this.$store.commit(mutationTypes.isAxialChange, value);
				this.$store.commit(mutationTypes.isSaggitalChange, value);
				this.$store.commit(mutationTypes.isCoronalChange, value);
				$(".dicom-container").css({ display: value ? "block" : "none" });
				updateAppLayout();
			}
		},
		isAxialLocal: {
			get: function () {
				return this.$store.state.dicom.isAxial;
			},
			set: function (value) {
				this.$store.commit(mutationTypes.isAxialChange, value);
				$("#axial_cont").css({ display: value ? "block" : "none" });
				updateAppLayout();
			}
		},
		isSaggitalLocal: {
			get: function () {
				return this.$store.state.dicom.isSaggital;
			},
			set: function (value) {
				this.$store.commit(mutationTypes.isSaggitalChange, value);
				$("#sagittal_cont").css({ display: value ? "block" : "none" });
				updateAppLayout();
			}
		},
		isCoronalLocal: {
			get: function () {
				return this.$store.state.dicom.isCoronal;
			},
			set: function (value) {
				this.$store.commit(mutationTypes.isCoronalChange, value);
				$("#coronal_cont").css({ display: value ? "block" : "none" });
				updateAppLayout();
			}
		},
		isLowQuality: {
			get: function () {
				return this.$store.state.dicom.isLowQuality;
			},
			set: function (value) {
				let needChange = value && !this.$store.state.dicom.isLowQuality;
				if (needChange || !DicomInitialized) {
					this.$store.commit(mutationTypes.isLowQualityChange, true);
					this.$store.commit(mutationTypes.isMiddleQualityChange, false);
					this.$store.commit(mutationTypes.isHighQualityChange, false);
					this.hideDicomMenu();
					updateDicomZipUrl(this.callbackAfterLoad);
				}
				else
					this.updateQualityCheckboxes();
			}
		},
		isMiddleQuality: {
			get: function () {
				return this.$store.state.dicom.isMiddleQuality;
			},
			set: function (value) {
				let needChange = value && !this.$store.state.dicom.isMiddleQuality;
				if (needChange || !DicomInitialized) {
					this.$store.commit(mutationTypes.isLowQualityChange, false);
					this.$store.commit(mutationTypes.isMiddleQualityChange, true);
					this.$store.commit(mutationTypes.isHighQualityChange, false);
					this.hideDicomMenu();
					updateDicomZipUrl(this.callbackAfterLoad);
				}
				else
					this.updateQualityCheckboxes();
			}
		},
		isHighQuality: {
			get: function () {
				return this.$store.state.dicom.isHighQuality;
			},
			set: function (value) {
				let needChange = value && !this.$store.state.dicom.isHighQuality;
				if (needChange || !DicomInitialized) {
					this.$store.commit(mutationTypes.isLowQualityChange, false);
					this.$store.commit(mutationTypes.isMiddleQualityChange, false);
					this.$store.commit(mutationTypes.isHighQualityChange, true);
					this.hideDicomMenu();
					updateDicomZipUrl(this.callbackAfterLoad);
				}
				else
					this.updateQualityCheckboxes();
			}
		},
	},
	methods: {
		crossSectionReportClick: function (event) {
			generateCrossSectionReport();
		},
		annotationModeClick: function (withBones) {
			changeAppTool(null, "annotation", withBones);
		},
		analysisModeClick: async function () {
			await enterAnalysisMode();
			// changeAppTool(null, "analysis");
		},
		allOnClick: function (event) {
			// console.log(this.isMobileDevice, vueApp.isMobileDevice);
			this.isAllLocal = !this.isAllLocal;
			console.log("allOnClick", this.isAllLocal, event);
			// event.preventDefault();
			// event.stopPropagation();
		},
		axialOnClick: function (event) {
			if (vueApp.isMobileDevice) {
				if (!this.isAxialLocal) {
					hideAllDicomPanels();
					this.isAxialLocal = true;
				}
			} else {
				this.isAxialLocal = !this.isAxialLocal;
			}
			// console.log("axialOnClick", this.isAxialLocal, event);
		},
		saggitalOnClick: function (event) {
			if (vueApp.isMobileDevice) {
				if (!this.isSaggitalLocal) {
					hideAllDicomPanels();
					this.isSaggitalLocal = true;
				}
			} else {
				this.isSaggitalLocal = !this.isSaggitalLocal;
			}
			// console.log("saggitalOnClick", this.isSaggitalLocal, event);
		},
		coronalOnClick: function (event) {
			if (vueApp.isMobileDevice) {
				if (!this.isCoronalLocal) {
					hideAllDicomPanels();
					this.isCoronalLocal = true;
				}
			} else {
				this.isCoronalLocal = !this.isCoronalLocal;
			}
			// console.log("coronalOnClick", this.isCoronalLocal, event);
		},
		hideDicomMenu: function () {
			if (!this.isLoaded) {
				document.getElementById("dicomSubMenu").classList.remove("show");
				document.getElementById("viewSubMenu").classList.remove("show");
				this.isLoaded = true;
			}
		},
		dicomLowClick: function (event) {
			gtag('event', `View->Dicom View->Basic`);
			console.log("dicomLowClick");
			this.isLowQuality = true;
		},
		dicomMiddleClick: function (event) {
			gtag('event', `View->Dicom View->High`);
			console.log("dicomMiddleClick");
			this.isMiddleQuality = true;
		},
		dicomHighClick: function (event) {
			gtag('event', `View->Dicom View->Original`);
			console.log("dicomHighClick");
			this.isHighQuality = true;
		},
		updateQualityCheckboxes: function () {
			$("#cbDicomLow").prop("checked", this.isLowQuality);
			$("#cbDicomMiddle").prop("checked", this.isMiddleQuality);
			$("#cbDicomHigh").prop("checked", this.isHighQuality);
			if (this.isFirstLoad) {
				this.callbackAfterLoad();
				this.hideDicomMenu();
			}
		},
		callbackAfterLoad: function () {
			$(".dicom-on-item").css({ display: "block" });
			$(".dicom-off-item").css({ display: "none" });
			if (this.isFirstLoad) {
				this.isFirstLoad = false;
				if (vueApp.isMobileDevice) {
					this.isAxialLocal = true;
				} else {
					this.isAllLocal = true;
				}
			} else {
				setTimeout(function () {
					updateAppLayout();
				}, 300);
			}
			this.updateQualityCheckboxes();
		}

	}
};
</script>

<style scoped>
.border-bottom-item {
	margin-bottom: 0;
}

.flex-menu-item {
	width: 85px;
	/* display: flex; */
	/* align-items: flex-end; */
	/* justify-content: center; */
}

.flex-separator {
	flex-grow: 1;
}

.dicom-on-item {
	display: none;
}

#cbDicomHigh {
	margin-left: 10px;
}

.disabled-label {
	font-weight: bold;
	margin: 0;
	padding: 0;
	/* padding-left: -10px;
	width: 100px; */
	/* color: white; */
}
</style>